module.exports = __webpack_public_path__ + "img/winter_wyvern.a2874dee.png";